import React from 'react';
import PropTypes from 'prop-types';
import { FDAlert } from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('StrongAlert', (theme) => ({
  error: {
    '& > div': {
      background: theme.palette.facet.brightRed30,
    },
  },
  info: {
    '& > div': {
      background: theme.palette.facet.oceana50,
    },
  },
}));

// StrongAlert uses the value you provide to make an FDAlert, but with a stronger color that works on the bone background - right now alert background colors are too washed out to be seen on bone backgrounds.
export const StrongAlert = ({
  status,
  value,
}) => {
  const classes = useStyles();
  return (
    <div className={classes[status]}>
      <FDAlert title={value} status={status} />
    </div>
  );
};

StrongAlert.defaultProps = {
  value: undefined,
};

StrongAlert.propTypes = {
  status: PropTypes.oneOf(['error', 'info']).isRequired,
  value: PropTypes.string,
};
